module.exports = __webpack_public_path__ + "static/Icons_SecondHome_large-725a63d4d1aba6aa2fd7eabfa6d1a9e9.png";